module.exports = __webpack_public_path__ + "images/img-16hCvR7.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/ranks/5.jpg
// module id = 2038
// module chunks = 0